import axios from 'axios';
import returnDomenLocation from '../helpers/returnDomainLoc';
import microserverConfig from '../helpers/microserverConfig';

// Offers microservice (offers.bookimed.{run,com}). The legacy monolith Vue admin
// called this host directly at /api/v1/questions, so we keep the same direct path
// instead of proxying through cms-api (cms-api has no questions endpoint).
const config = () => ({
  baseURL: `${returnDomenLocation('offers')}api/v1`,
});

export default microserverConfig(axios.create(config()));
